import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "base-radio" }
const _hoisted_2 = {
  key: 0,
  class: "label"
}
const _hoisted_3 = { class: "options" }
const _hoisted_4 = ["onUpdate:modelValue", "name", "id", "onChange"]
const _hoisted_5 = ["for"]

import { ref, watchEffect } from "vue";
import { useI18n } from "vue-i18n";

interface OptionType {
  id: string;
  option: string;
  value: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'base-checkbox',
  props: {
    id: {},
    options: {},
    width: { default: "100%" },
    value: {}
  },
  emits: ["update:modelValue", "change", "checked"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "v77ea1b91": (_ctx.width)
}))

const emit = __emit;

const props = __props;

const internalValue = ref<OptionType[]>([]);

async function update(data: OptionType) {
  emit("checked", data);
  await new Promise((resolve) => setTimeout(() => resolve(true), 100));
  emit("change", internalValue.value);
}

function fetchValue() {
  if (props.value) {
    internalValue.value = props.options.map((item) => {
      const matchedOption = props.value.find((option) => option.id === item.id);
      return { ...item, value: matchedOption ? matchedOption.value : false };
    });
  } else {
    internalValue.value = props.options.map((option) => ({
      ...option,
      value: false,
    }));
  }
}

watchEffect(() => {
  if (props.options) fetchValue();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.$slots.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "label")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(internalValue.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "option"
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": ($event: any) => ((item.value) = $event),
            name: __props.id,
            id: `${__props.id}${index}`,
            onChange: ($event: any) => (update(item))
          }, null, 40, _hoisted_4), [
            [_vModelCheckbox, item.value]
          ]),
          _createElementVNode("label", {
            for: `${__props.id}${index}`
          }, _toDisplayString(item.option), 9, _hoisted_5)
        ]))
      }), 128))
    ])
  ]))
}
}

})